import { createReducer } from './utils';
import {
  handleAvailable,
  handleRequest,
  handleUnavailable,
} from '../reducerHandlers';

import {
  CLIENTS_REQUEST,
  CLIENTS_AVAILABLE,
  CLIENTS_UNAVAILABLE,
  SNACK_SET,
} from './constants';

const defaultState = {
  loading_client_info: false,
  loading_client_types: false,
  loading_clients: false,
  loading_client_stores: false,
  clients: false,
  clientList: [],
  clientTypesList: [],
  clientInfo: {},
  clientStores: [],
  clientFormats: {},
  loadingClientFormats: false,
  clientPermissions: null,
  loadingClientPermissions: false,
};

export const reducer = createReducer(defaultState, {
  [CLIENTS_REQUEST]: handleRequest,
  [CLIENTS_AVAILABLE]: handleAvailable,
  [CLIENTS_UNAVAILABLE]: handleUnavailable,
});

export function getClientsTypes() {
  return async (dispatch, _, { services: { dataSource } }) => {
    dispatch({
      type: CLIENTS_REQUEST,
      payload: { loadingName: 'loading_client_types' },
    });
    try {
      const clientTypesResponse = await dataSource.getClientsTypes();
      dispatch({
        type: CLIENTS_AVAILABLE,
        payload: {
          keyState: 'clientTypesList',
          loadingName: 'loading_client_types',
          data: clientTypesResponse.client_types,
        },
      });
    } catch (error) {
      console.log('error: ', error);
      dispatch({
        type: CLIENTS_UNAVAILABLE,
        payload: {
          error,
          keyState: 'clientTypesList',
          loadingName: 'loading_client_types',
          defaultState: [],
        },
      });
      const snack = {
        open: true,
        message: 'There was an error',
        severity: 'error',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}

export function getClientInfo(client_id) {
  return async (dispatch, _, { services: { dataSource } }) => {
    dispatch({
      type: CLIENTS_REQUEST,
      payload: { loadingName: 'loading_client_info' },
    });
    try {
      const clientInfoResponse = await dataSource.getClientInfo(client_id);
      dispatch({
        type: CLIENTS_AVAILABLE,
        payload: {
          keyState: 'clientInfo',
          loadingName: 'loading_client_info',
          data: clientInfoResponse.client_info,
        },
      });
    } catch (error) {
      console.log('error: ', error);
      dispatch({
        type: CLIENTS_UNAVAILABLE,
        payload: {
          error,
          keyState: 'clientInfo',
          loadingName: 'loading_client_info',
          defaultState: {},
        },
      });
      const snack = {
        open: true,
        message: 'There was an error',
        severity: 'error',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}

export function postNewClient(fileForm) {
  return async (dispatch, _, { services: { dataSource } }) => {
    const loadingName = 'loading_new_client';

    dispatch({ type: CLIENTS_REQUEST, payload: { loadingName } });
    try {
      const response = await dataSource.postNewClient(fileForm);
      alert('cliente creado exitosamente');
      dispatch({
        type: CLIENTS_AVAILABLE,
        payload: { loadingName },
      });
    } catch (error) {
      console.log('error: ', error);
      alert('error al crear cliente');
      dispatch({
        type: CLIENTS_UNAVAILABLE,
        payload: { error, loadingName },
      });
      const snack = {
        open: true,
        message: 'There was an error',
        severity: 'error',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}

export function patchClient(fileForm) {
  return async (dispatch, _, { services: { dataSource } }) => {
    const loadingName = 'loading_patch_client';

    dispatch({ type: CLIENTS_REQUEST, payload: { loadingName } });
    try {
      const response = await dataSource.patchClient(fileForm);
      // TODO: translate
      alert('cliente editado exitosamente');
      dispatch({
        type: CLIENTS_AVAILABLE,
        payload: { loadingName },
      });
    } catch (error) {
      console.log('error: ', error);
      alert('error al editar cliente');
      dispatch({
        type: CLIENTS_UNAVAILABLE,
        payload: { error, loadingName },
      });
      const snack = {
        open: true,
        message: 'There was an error',
        severity: 'error',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}

export function getClientStores(client_id) {
  return async (dispatch, _, { services: { dataSource } }) => {
    dispatch({
      type: CLIENTS_REQUEST,
      payload: { loadingName: 'loading_client_stores' },
    });
    try {
      const response = await dataSource.getClientStores(client_id);
      dispatch({
        type: CLIENTS_AVAILABLE,
        payload: {
          keyState: 'clientStores',
          loadingName: 'loading_client_stores',
          data: response,
        },
      });
    } catch (error) {
      console.log('error: ', error);
      dispatch({
        type: CLIENTS_UNAVAILABLE,
        payload: {
          error,
          keyState: 'clientStores',
          loadingName: 'loading_client_stores',
          defaultState: [],
        },
      });
      const snack = {
        open: true,
        message: 'Error in getting client stores',
        severity: 'error',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}

export function getClientFormats(client_id) {
  return async (dispatch, _, { services: { dataSource } }) => {
    const keyState = 'clientFormats';
    const loadingName = 'loadingClientFormats';
    dispatch({ type: CLIENTS_REQUEST, payload: { loadingName: loadingName } });
    try {
      const response = await dataSource.getClientFormats(client_id);
      dispatch({
        type: CLIENTS_AVAILABLE,
        payload: { data: response, keyState, loadingName },
      });
    } catch (error) {
      console.log('error: ', error);
      dispatch({
        type: CLIENTS_UNAVAILABLE,
        payload: { error, keyState, loadingName, defaultState: {} },
      });
      const snack = {
        open: true,
        message: 'There was an error getting the client formats.',
        severity: 'error',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}

export function getAllGroups() {
  return async (dispatch, _, { services: { dataSource } }) => {
    const keyState = 'allGroups';
    const loadingName = 'loadingAllGroups';

    dispatch({ type: CLIENTS_REQUEST, payload: { loadingName: loadingName } });
    try {
      const response = await dataSource.getAllGroups();
      dispatch({
        type: CLIENTS_AVAILABLE,
        payload: { data: response, keyState, loadingName },
      });
    } catch (error) {
      console.log('error: ', error);
      dispatch({
        type: CLIENTS_UNAVAILABLE,
        payload: { error, keyState, loadingName, defaultState: null },
      });
      const snack = {
        open: true,
        message: 'There was an error getting the client permissions.',
        severity: 'error',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}

export function getPermissions(client_id) {
  return async (dispatch, _, { services: { dataSource } }) => {
    const keyState = 'clientPermissions';
    const loadingName = 'loadingClientPermissions';

    dispatch({ type: CLIENTS_REQUEST, payload: { loadingName: loadingName } });
    try {
      const response = await dataSource.getClientPermissions(client_id);
      dispatch({
        type: CLIENTS_AVAILABLE,
        payload: { data: response, keyState, loadingName },
      });
    } catch (error) {
      console.log('error: ', error);
      dispatch({
        type: CLIENTS_UNAVAILABLE,
        payload: { error, keyState, loadingName, defaultState: null },
      });
      const snack = {
        open: true,
        message: 'There was an error getting the client permissions.',
        severity: 'error',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}

export function updatePermissions(client_id, payload) {
  return async (dispatch, _, { services: { dataSource } }) => {
    const loadingName = 'loadingClientPermissions';

    dispatch({ type: CLIENTS_REQUEST, payload: { loadingName } });
    try {
      await dataSource.updateClientPermissions(client_id, payload);

      const snack = {
        open: true,
        message: 'Permissions updated successfully.',
        severity: 'success',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });

      dispatch(getPermissions(client_id));
    } catch (error) {
      console.log('error: ', error);
      dispatch({
        type: CLIENTS_UNAVAILABLE,
        payload: {
          error,
          keyState: 'clientPermissions',
          loadingName,
          defaultState: null,
        },
      });
      const snack = {
        open: true,
        message: 'There was an error updating the client permissions.',
        severity: 'error',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}
